var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "0.45634cm",
    height: "0.34761cm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 13.42 10.22",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2623573402512"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7526FE",
    d: "M0.68 0.1c0.03,0.13 1.39,1.42 1.47,1.51 0.26,0.26 4.4,4.43 4.53,4.51 0.11,-0.08 0.27,-0.25 0.37,-0.36 0.14,-0.14 0.26,-0.23 0.39,-0.37l0.58 -0.55c0.07,-0.07 0.12,-0.13 0.2,-0.2l4.34 -4.34c0.07,-0.07 0.15,-0.11 0.18,-0.22 -0.09,-0.04 -0.28,-0.1 -0.42,-0.1l-11.22 0c-0.14,0 -0.33,0.06 -0.42,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7526FE",
    d: "M0.68 10.12c0.09,0.04 0.28,0.1 0.42,0.1l11.22 0c0.14,0 0.33,-0.06 0.42,-0.1 -0.03,-0.12 -0.97,-1.01 -1.08,-1.12 -0.26,-0.26 -3.21,-3.25 -3.35,-3.34l-1.34 1.28c-0.07,0.08 -0.14,0.12 -0.26,0.13 -0.21,0.01 -0.33,-0.16 -0.45,-0.28l-1.15 -1.13c-0.13,0.09 -3.67,3.66 -4.16,4.15 -0.08,0.08 -0.24,0.19 -0.27,0.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7526FE",
    d: "M8.86 5.11c0.09,0.13 3.66,3.67 4.15,4.16 0.08,0.08 0.19,0.24 0.31,0.27 0.04,-0.09 0.1,-0.28 0.1,-0.42l0 -8.02c0,-0.14 -0.06,-0.33 -0.1,-0.42 -0.12,0.03 -1.01,0.97 -1.12,1.08 -0.38,0.38 -0.74,0.74 -1.11,1.11 -0.16,0.16 -2.14,2.11 -2.22,2.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7526FE",
    d: "M-0 1.1l0 8.02c0,0.14 0.06,0.33 0.1,0.42 0.12,-0.03 1.01,-0.97 1.12,-1.08 0.38,-0.38 0.74,-0.74 1.11,-1.11 0.16,-0.16 2.14,-2.11 2.22,-2.23 -0.09,-0.13 -3.66,-3.67 -4.15,-4.16 -0.08,-0.08 -0.19,-0.24 -0.31,-0.27 -0.04,0.09 -0.1,0.28 -0.1,0.42z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconEmail);
export default __webpack_public_path__ + "static/media/homeIconEmail.b2ea7ccabfb081c1088d974a47163bab.svg";
export { ForwardRef as ReactComponent };